import { IInfrastructureItemV4Schema as IInfrastructureItemScheme } from 'shared/repositories/infrastructure-caching/entities/newbuilding_infrastructure/InfrastructureItemV4Schema';

export { IMetroLineSchema as IMetroLine } from 'shared/repositories/infrastructure-caching/entities/newbuilding_infrastructure/MetroLineSchema';

export interface IInfrastructureCategory {
  /** Заголовок категории */
  title: string;
  /** Тип категории */
  type: string;
  /** Объекты инфраструктуры данной категории */
  items: IInfrastructureItem[];
  /** Иконка категории */
  icon: string;
}

export interface IInfrastructureItem extends Omit<IInfrastructureItemScheme, 'type'> {
  type: string;
  /** Иконка объекта инфраструктуры (нужна для пина на карте) */
  icon: string;
}

export interface IInfrastructure {
  data: IInfrastructureCategory[];
  status: EInfrastructureStatus;
}

export enum EInfrastructureStatus {
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'failed',
}
